module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel02_770_280_ja-c44f6ddfa5b7d74220c48f0e22ec2ddb.jpg";